import FusionCharts from 'fusioncharts'
import charts from 'fusioncharts/fusioncharts.charts'
import ReactFusioncharts from 'react-fusioncharts'
import React, { useRef } from 'react'
import { ViewerChartPeriod, ViewerData } from './types'
import moment from 'moment'
// import { User } from '../../../utilities'
// import styles from './DualAxis.module.scss'
import { ToolTipContent } from '../MSLine/ToolTipContent'
import { Series } from '../MSLine'
import ReactDOM from 'react-dom'
import { dataSource, useCategoryToolTipProps } from './DualAxis.utils'
import { CategoryToolTip } from '../MSLine/CategoryToolTip'
import { formatPrice, getToFixed2Number } from 'utilities'
import { parseMilliseconds } from "store/StatisticsPageStore/StatisticsPage.utils"

// Resolves charts dependancy
charts(FusionCharts)

const DualAxisComponent = (props: ViewerData) => {
  const data: Map<String, ViewerChartPeriod> = props.data

  const processViewersData = (data: Map<String, ViewerChartPeriod>) => {
    const category = []
    const ads = []
    const watch = []
    const vovWatch = []
    const interaction = []
    const pageInteraction = []
    const vovInteraction = []
    const revenue = []
    const keys = new Array(...data.keys())
    keys.forEach((key) => {
      category.push({ label: key })
      ads.push({ value: data.get(key)?.revenue })
      watch.push({ value: moment.duration(data.get(key)?.totalWatchTime, 'milliseconds').asHours() })
      vovWatch.push({ value: moment.duration(data.get(key)?.totalVovWatchTime, 'milliseconds').asHours() })
      interaction.push({ value: moment.duration(data.get(key)?.totalInteractionTime, 'milliseconds').asHours() })
      pageInteraction.push({ value: moment.duration(data.get(key)?.totalPageInteractionTime, 'milliseconds').asHours() })
      vovInteraction.push({ value: moment.duration(data.get(key)?.totalVovInteractionTime, 'milliseconds').asHours() })
      revenue.push({ value: data.get(key)?.totalOrders })
    })
    dataSource.categories[0].category = category
    dataSource.dataset[0].data = ads
    dataSource.dataset[1].data = revenue
    dataSource.dataset[2].data = watch
    dataSource.dataset[3].data = interaction
    dataSource.dataset[4].data = pageInteraction
    dataSource.dataset[5].data = vovInteraction
    dataSource.dataset[6].data = vovWatch
  }
  processViewersData(data)

  const chartContainer = useRef<ReactFusioncharts>(null)
  const { categoryToolTipProps } = useCategoryToolTipProps(chartContainer, dataSource)

  const onDataPlotRollOver = (ev) => {
    const parsedTime = parseMilliseconds(ev?.data?.value);
    const formattedTime = `${moment.duration(parsedTime.value, parsedTime.label).format('h:m:ss')} ${parsedTime.label}`
    const headerValue = ev?.data?.categoryLabel
    const color = ev?.data?.anchorBgColor
    const dataIndex = ev?.data?.dataIndex
    const series: Series = ev?.sender?.originalDataSource?.dataset?.find(v =>
      v.seriesname === ev?.data?.datasetName && v.color === color)
    const label = ev?.data?.datasetName || series?.data?.[dataIndex]?.entityName
    const isPrice = label.includes('revenue')
    const value = isPrice
      ? formatPrice(ev?.data?.value)
      : formattedTime
    const image = series?.image || series?.data?.[dataIndex]?.entityImage
    const headerLabel = series?.isBest
      ? 'Maximum value'
      : isPrice
        ? ev?.sender?.originalDataSource?.chart?.syAxisName
        : ev?.sender?.originalDataSource?.chart?.yAxisName

    ReactDOM.render(
      <ToolTipContent
        header={{ label: headerLabel, value: headerValue }}
        list={[
          {
            label,
            value,
            color: series?.isBest ? undefined : (color || `#${ev?.data.hoverColor}`),
            image
          }
        ]}
      />,
      document.getElementById('divToolTip')
    )
  }

  return (
    <div style={{ width: '100%' }}>
      <ReactFusioncharts
        ref={chartContainer}
        type='mscombidy2d'
        width='100%'
        height='40%'
        dataFormat='JSON'
        dataSource={dataSource}
        containerBackgroundColor='transparent'
        events={{
          dataPlotRollOver: onDataPlotRollOver
        }}
      />
      {categoryToolTipProps && (
        <CategoryToolTip
          {...categoryToolTipProps}
        />
      )}
    </div>
  )
}

const DualAxis = DualAxisComponent
export { DualAxis }
